import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
})
export class LinkComponent implements OnInit {

  constructor( private router: Router) { }

  ngOnInit() {}

  backButtonHandler(){
    this.router.navigate(['/questionnaire/result']);
  }

}
